var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
// style-------------------------------------------------------------------
var Ahover = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  :hover {\n    text-decoration: underline !important;\n    color: blue !important;\n    transition: color 0.15s;\n  }\n"], ["\n  :hover {\n    text-decoration: underline !important;\n    color: blue !important;\n    transition: color 0.15s;\n  }\n"])));
// component-------------------------------------------------------------------
var StyleA = function (props) {
    var children = props.children, other = __rest(props, ["children"]);
    return React.createElement(Ahover, __assign({}, other), children);
};
export default StyleA;
var templateObject_1;
